
/* Protopia Ecosystem component */
export interface IFinishResultMessageProps {
   
}
const FinishResultMessage = (props: IFinishResultMessageProps): JSX.Element => {
    return <div className='pe-finish-result-message-container'> </div>
}
export default FinishResultMessage